/* 開梱・組立・設置サービス — Impulse (Archetype Themes) 対応版
 *
 * 料金は1注文につき1回。商品の点数・数量にかかわらず ¥6,000。
 *
 * 設計方針:
 *   テーマのカート投入処理は一切置き換えません。
 *   1) 'ajaxProduct:added' を受けてサービス商品が1つだけ入るよう調整
 *   2) 'cart:updated' を受けて、設置希望の商品が無くなればサービスも外す
 *   3) サービス単独でのチェックアウトを止める
 */
(function () {
  'use strict';

  var CFG = window.InstallService;
  if (!CFG || !CFG.variantId) return;

  console.log('[install-service] 読み込み完了');

  /* ------------------------------------------------------------------
   * 1. 商品ページのチェックボックス
   *
   * 要素の初期化は行いません。document 上でイベントを受けるので、
   * ブロックがいつ描画されても動きます。
   * hidden input は Liquid 側で disabled 付きで出力しているため、
   * 未チェックの初期状態は JS なしでも正しくなります。
   * ------------------------------------------------------------------ */

  document.addEventListener('change', function (event) {
    var checkbox = event.target;
    if (!checkbox.matches || !checkbox.matches('[data-install-checkbox]')) return;

    var root = checkbox.closest('[data-install-service]');
    if (!root) return;

    var flagInput = root.querySelector('[data-install-flag]');
    if (!flagInput) return;

    flagInput.disabled = !checkbox.checked;
    flagInput.value = checkbox.checked ? CFG.flagValue : '';
    root.classList.toggle('is-selected', checkbox.checked);
  });

  /* ------------------------------------------------------------------
   * 2. カート内のサービス行を「あるべき状態」に合わせる
   *
   *   設置希望の商品が1つでもある → サービスを数量1で入れる
   *   1つもない                   → サービスを外す
   * ------------------------------------------------------------------ */

  var syncing = false;

  function isServiceLine(line) {
    return line.variant_id === CFG.variantId;
  }

  function wantsInstall(line) {
    return line.properties && line.properties[CFG.flagKey] === CFG.flagValue;
  }

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); });
  }

  function postJSON(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (e) { throw e; });
      return res.json();
    });
  }

  function reconcileService() {
    if (syncing) return Promise.resolve(false);
    syncing = true;

    return getCart()
      .then(function (cart) {
        var desired = 0;
        var serviceLineNumber = 0;
        var serviceQty = 0;

        cart.items.forEach(function (line, index) {
          if (isServiceLine(line)) {
            serviceLineNumber = index + 1; // change.js の line は1始まり
            serviceQty = line.quantity;
          } else if (wantsInstall(line)) {
            desired = 1; // 何点あっても1回
          }
        });

        if (serviceLineNumber) {
          if (serviceQty === desired) return false;
          // 数量を1に揃える、または0にして取り除く
          return postJSON('/cart/change.js', {
            line: serviceLineNumber,
            quantity: desired
          }).then(function () { return true; });
        }

        if (desired === 1) {
          return postJSON('/cart/add.js', {
            items: [{ id: CFG.variantId, quantity: 1 }]
          }).then(function () { return true; });
        }

        return false;
      })
      .then(function (changed) {
        syncing = false;
        return changed;
      })
      .catch(function (err) {
        syncing = false;
        console.error('[install-service] カートの同期に失敗', err);
        return false;
      });
  }

  /* ------------------------------------------------------------------
   * 3. チェックアウトの制御
   * ------------------------------------------------------------------ */

  function guardCheckout() {
    return getCart().then(function (cart) {
      var hasOther = cart.items.some(function (line) { return !isServiceLine(line); });
      var blocked = cart.items.length > 0 && !hasOther;

      document
        .querySelectorAll('[name="checkout"], .cart__checkout, [data-checkout-button]')
        .forEach(function (button) {
          button.disabled = blocked;
          button.setAttribute('title', blocked ? '設置サービスのみのご購入はできません。' : '');
        });
    });
  }

  function refresh() {
    return reconcileService().then(function (changed) {
      if (changed) {
        document.dispatchEvent(new CustomEvent('cart:build'));
      } else {
        guardCheckout();
      }
    });
  }

  /* ------------------------------------------------------------------
   * 4. Impulse のイベントに接続する
   * ------------------------------------------------------------------ */

  document.addEventListener('ajaxProduct:added', function (event) {
    var line = event.detail && event.detail.product;
    if (!line || !line.properties) return;
    if (line.properties[CFG.flagKey] !== CFG.flagValue) return;
    refresh();
  });

  // Impulse はカート数量を変更するたびに cart:updated を発火します
  document.addEventListener('cart:updated', refresh);

  /* ------------------------------------------------------------------ */

  function boot() {
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();